export enum EmailValidityStatus {
  NEW,
  VALID,
  INVALID,
  DUPLICATE
};

export enum WebsocketType {
  SIGNING_FLOW_CHANGED = 'SIGNING_FLOW_CHANGED',
  DOCUMENT_STATE_CHANGED = 'DOCUMENT_STATE_CHANGED',
  SIGNING_SESSION_EXPIRED = 'SIGNING_SESSION_EXPIRED',
  DOCUMENT_SIGNING_SUCCESSFUL = 'DOCUMENT_SIGNING_SUCCESSFUL',
  SIGNING_SESSION_WAS_OVERRIDDEN = 'SIGNING_SESSION_WAS_OVERRIDDEN',
  STOMP_ERROR = 'STOMP_ERROR',
  SIGNING_CALLBACK_ERROR = 'SIGNING_CALLBACK_ERROR',
};

export enum TableFilter {
  MY_REQUESTS_TABLE_FILTER_ALL = 'MY_REQUESTS_TABLE_FILTER_ALL',
  MY_REQUESTS_TABLE_FILTER_PENDING = 'MY_REQUESTS_TABLE_FILTER_PENDING',
  MY_REQUESTS_TABLE_FILTER_COMPLETED = 'MY_REQUESTS_TABLE_FILTER_COMPLETED',
  MY_REQUESTS_TABLE_FILTER_CANCELLED = 'MY_REQUESTS_TABLE_FILTER_CANCELLED'
};

export enum ActionResult {
  UNDEFINED,
  SUCCESS,
  ERROR
};

export enum UploadDocumentMessage {
  UNDEFINED,
  FILE_TOO_BIG,
  UNSUPPORTED_FILE_TYPE,
  UPLOAD_ERROR,
};

export enum SigningStatus {
  NEW = "NEW",
  FAILED = "FAILED",
  DECLINED = "DECLINED",
  COMPLETED = "COMPLETED",
  SUCCESSFULLY_DECLINED = "SUCCESSFULLY_DECLINED",
  READY_FOR_SIGNING = "READY_FOR_SIGNING",
  SUCCESFULLY_SIGNED = "SUCCESFULLY_SIGNED",

  OBJECT_LOCKED = "OBJECT_LOCKED",
  SERVER_SIDE_ERROR = "SERVER_SIDE_ERROR",
  NOT_IN_ORDER_TO_SIGN = "NOT_IN_ORDER_TO_SIGN",
  DOCUMENT_STATE_CHANGED = "DOCUMENT_STATE_CHANGED",
  SIGNING_SESSION_EXPIRED = "SIGNING_SESSION_EXPIRED",
  UNAUTHORIZED_ASSET_ACCESS = "UNAUTHORIZED_ASSET_ACCESS",
  SIGNING_SESSION_WAS_OVERRIDDEN = "SIGNING_SESSION_WAS_OVERRIDDEN",
  STOMP_ERROR = "STOMP_ERROR",
  SIGNING_CALLBACK_ERROR = "SIGNING_CALLBACK_ERROR",
  
  UNEXPECTED = "UNEXPECTED",
};

export enum SigningErrorStatus {
  OBJECT_LOCKED = "OBJECT_LOCKED",
  SERVER_SIDE_ERROR = "SERVER_SIDE_ERROR",
  NOT_IN_PENDING_STATE = "NOT_IN_PENDING_STATE",
  NOT_IN_ORDER_TO_SIGN = "NOT_IN_ORDER_TO_SIGN"
};

export enum ServerErrorDescription {
  TASK_LOAD_ERROR = 'TASK_LOAD_ERROR',
  TASK_STATUS_LOAD_ERROR = 'TASK_STATUS_LOAD_ERROR',
  FLOW_LOAD_ERROR = 'FLOW_LOAD_ERROR',
  FIELD_DEFINITION_LOAD_ERROR = 'FIELD_DEFINITION_LOAD_ERROR',
  FILE_LOAD_ERROR = 'FILE_LOAD_ERROR',
  NO_ACTIVE_SUBSCRIPTION = 'NO_ACTIVE_SUBSCRIPTION',
  PROVIDED_JWT_IS_INVALID = 'PROVIDED_JWT_IS_INVALID'
};

export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Disabled = 'disabled',
  Next = 'next',
  Previous = 'previous',
};

export enum SigningTaskStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
  COMPLETED = 'COMPLETED',
};

export enum SigningFlowStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_WITH_ERRORS = 'IN_PROGRESS_WITH_ERRORS',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
};

export enum QTableTaskIcon {
  CHECK = 'check',
  CLOSE = 'close',
  HOURGLASS_EMPTY = 'hourglass_empty'
};

export enum LicenseVerificationState {
  NONE = 'NONE',
  HAS_ACTIVE_LICENSE = 'HAS_ACTIVE_LICENSE',
  NO_ACTIVE_LICENSE = 'NO_ACTIVE_LICENSE',
  EXCEEDED_SUBSCRIPTION_LIMIT = 'EXCEEDED_SUBSCRIPTION_LIMIT'
};

export enum RequestsFetchState {
  NONE = 'NONE',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_SUCCESS_AND_EMPTY = 'FETCH_SUCCESS_AND_EMPTY',
  FETCH_ERROR = 'FETCH_ERROR'
};